import {
	OpenAccountDataToGetApplication,
	OpenAccountDataToGetClientInfo, OpenAccountDataToGetInvoiceList,
	OpenAccountDataToSendCode,
	OpenAccountDataToVerifyCode,
	OpenAccountInvoice,
	OpenAccountLegalEntity
} from "@/feature/OpenAccount/store/interface";
import api from '@/api';
import { isSuccessResponseStatusCode } from "@/api/handler";

export const $sendOpenAccountConfirmationCode = async (
	dataToSendCode: OpenAccountDataToSendCode
): Promise<string> => api
	.post(
		process.env.VUE_APP_HOST_URL +
		process.env.VUE_APP_FL_API_URL +
		'auth/non-customer/login',
		dataToSendCode,
		{ handler: { dontUseApiUrl: true } }
	)
	.then(response => response?.message || '')
	.then(() => dataToSendCode.phoneNumber);

export const $verifyOpenAccountConfirmationCode = async (
	dataToVerifyCode: OpenAccountDataToVerifyCode
): Promise<boolean> => api
	.post(
		process.env.VUE_APP_HOST_URL +
		process.env.VUE_APP_FL_API_URL +
		'auth/non-customer/login/verify',
		dataToVerifyCode,
		{ handler: { dontUseApiUrl: true, returnData: false } }
	)
	.then(response => isSuccessResponseStatusCode(response?.status))
	// .then(() => true);

export const $getLegalEntityInfo = async (
	dataToGetClientInfo: OpenAccountDataToGetClientInfo
): Promise<OpenAccountLegalEntity | null> => api
	.post(
		'open-account/get-legal-entity-info-tin',
		dataToGetClientInfo,
		{ handler: { returnData: false, disableLoader: true } }
	)
	.then(async response => response?.data || null)
	// .then(() => ({
	// 	"legalEntityState": "POTENTIAL",
	// 	"isMainAccount": true,
	// 	"legalEntityName": "OOO \"EXIM ASIA SAVDO\"",
	// 	"crmId": "0001010400",
	// 	"mfo": "01041",
	// 	"nciId": "04555645",
	// 	"registrationDateStart": "2006-11-20T00:00:00",
	// 	"registrationDateEnd": null,
	// 	"registrationAddress": "Tashkent city",
	// 	"pinfl": null
	// } as any));

export const $getOpenAccountInvoiceList = async (
	params: OpenAccountDataToGetInvoiceList
): Promise<OpenAccountInvoice[]> => api
	.get('open-account/get-application-list', {
		request: { params }
	})
	.then(response => response || [])
	// .then(() => ([
	// 	{
	// 		"applicationId": "1",
	// 		"applicationNumber": "1234567890",
	// 		"applicationDateTime": "2021-11-19T00:00:00",
	// 		"inn": "495960907",
	// 		"pinfl": null,
	// 		"legalEntityName": "YTT \"ADIZOV WORLD XUDAYBERDIYEVICH\"",
	// 		"applicationStatus": "DECLINED_BY_BANK"
	// 	},
	// 	{
	// 		"applicationId": "1",
	// 		"applicationNumber": "1234567890",
	// 		"applicationDateTime": "2021-11-19T00:00:00",
	// 		"inn": null,
	// 		"pinfl": '12345678901234',
	// 		"legalEntityName": "YTT \"HELLO XURSHID XUDAYBERDIYEVICH\"",
	// 		"applicationStatus": "DECLINED_BY_CUSTOMER"
	// 	},
	// 	{
	// 		"applicationId": "1",
	// 		"applicationNumber": "1234567890",
	// 		"applicationDateTime": "2021-11-19T00:00:00",
	// 		"inn": "495960907",
	// 		"pinfl": null,
	// 		"legalEntityName": "YTT \"ADIZOV XURSHID XUDAYBERDIYEVICH\"",
	// 		"applicationStatus": "ACCOUNT_OPENED"
	// 	},
	// 	{
	// 		"applicationId": "1",
	// 		"applicationNumber": "1234567890",
	// 		"applicationDateTime": "2021-11-19T00:00:00",
	// 		"inn": null,
	// 		"pinfl": '12345678901234',
	// 		"legalEntityName": "YTT \"ADIZOV XURSHID XUDAYBERDIYEVICH\"",
	// 		"applicationStatus": "OPEN"
	// 	},
	// 	{
	// 		"applicationId": "1",
	// 		"applicationNumber": "1234567890",
	// 		"applicationDateTime": "2021-11-19T00:00:00",
	// 		"inn": "495960907",
	// 		"pinfl": null,
	// 		"legalEntityName": "YTT \"ADIZOV XURSHID XUDAYBERDIYEVICH\"",
	// 		"applicationStatus": "OPEN"
	// 	}
	// ]) as any);

export const $getOpenAccountInvoice = async (
	params: OpenAccountDataToGetApplication
): Promise<OpenAccountInvoice | null> => api
	.get('open-account/get-application', {
		request: { params }
	});

export const $createOpenAccountInvoice = async (
	params: OpenAccountDataToGetInvoiceList
): Promise<OpenAccountInvoice | null> => api
	.post('open-account/create-application', params);